import { render, staticRenderFns } from "./OutletPromotionalItems.vue?vue&type=template&id=349cabb6&"
import script from "./OutletPromotionalItems.vue?vue&type=script&lang=js&"
export * from "./OutletPromotionalItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports